import curdGenerator from "./curdGenerator";

export const ipd = [
  {
    module: "IPD",
    children: [
      {
        module: "Masters",
        children: [
          curdGenerator("Room Category"),
          curdGenerator("Nursing Station"),
          curdGenerator("Room")
        ]
      },
      {
        module: "Transactions",
        children: [
          curdGenerator("IPD Registration"),
          curdGenerator("Payment Receive"),
          curdGenerator("Room Change"),
          curdGenerator("IPD Bill Charges"),
          curdGenerator("Delivery"),
          curdGenerator("Patient History"),
          curdGenerator("IPD Refund"),
          curdGenerator("Patient Discharge"),
          curdGenerator("Discharge Card"),
          curdGenerator("IPD Medical Certificate"),
          curdGenerator("Mlc"),
          curdGenerator("Oxygen Given"),
          curdGenerator("Death Certificate"),
          curdGenerator("IPD Consultant Change")
        ]
      },
      {
        module: "Reports",
        children: [
          {
            module: "IPD Registration Report",
            permission: "ipdregistrationreport",
            children: []
          },
          { module: "Birth Report", permission: "birthreport", children: [] },
          { module: "MTP Report", permission: "mtpreport", children: [] },
          {
            module: "Room Change Report",
            permission: "roomchangereport",
            children: []
          },
          {
            module: "Discharge Report",
            permission: "dischargereport",
            children: []
          },
          {
            module: "Discharge Patient Status Report",
            permission: "dischargepatientstatusreport",
            children: []
          },
          {
            module: "Discharge Patient Dues Report",
            permission: "dischargepatientduesreport",
            children: []
          },
          {
            module: "Doctor Wise Patient Status Report",
            permission: "doctorwisepatientstatusreport",
            children: []
          },
          {
            module: "In Patient Report",
            permission: "inpatientreport",
            children: []
          },
          {
            module: "Department Census Report",
            permission: "departmentcensusreport",
            children: []
          },
          {
            module: "Discharge Bill Report",
            permission: "dischargebillreport",
            children: []
          },
          {
            module: "Discount Report",
            permission: "discountreport",
            children: []
          },
          {
            module: "IPD Charges Report",
            permission: "ipdchargesreport",
            children: []
          },
          {
            module: "Group Wise IPD Charges Report",
            permission: "ipdgroupwisechargesreport",
            children: []
          },
          {
            module: "IPD Patient Consultant Wise Report",
            permission: "ipdpatientconsultantwisereport",
            children: []
          },
          {
            module: "IPD Patient Receipts Report",
            permission: "ipdpatientreceiptsreport",
            children: []
          },
          { module: "MLC Report", permission: "mlcreport", children: [] },
          {
            module: "IPD Refund Report",
            permission: "ipdrefundreport",
            children: []
          },
          {
            module: "Room Category Wise Report",
            permission: "roomcategorywisereport",
            children: []
          },
          {
            module: "IPD Gender Wise Report",
            permission: "ipdgenderwisereport",
            children: []
          }
        ]
      },
      {
        module: "OT Management",
        children: [
          curdGenerator("Operation Booking"),
          curdGenerator("Operation Notes"),
          {
            module: "Operation Booking Report",
            permission: "operationbookingreport",
            children: []
          },
          {
            module: "Operation Report",
            permission: "operationreport",
            children: []
          }
        ]
      },
      {
        module: "Help Desk",
        children: [
          {
            module: "Patient Status",
            permission: "patientstatus",
            children: []
          },
          { module: "IPD Enquiry", permission: "ipdenquiry", children: [] },
          {
            module: "Patient Search",
            permission: "patientsearch",
            children: []
          }
        ]
      }
    ]
  }
];
